// product grid/list view toggle (list view UI disabled — keep grid only)
function setProductView(mode) {
  var grid = document.getElementById('product-grid');
  if (!grid) return;

  // Force grid — list view option removed from theme
  mode = 'grid';

  document.querySelectorAll('.wblistgridbtn').forEach(function (btn) {
    btn.classList.remove('active');
    if (btn.classList.contains('gridv')) {
      btn.classList.add('active');
    }
  });

  grid.classList.add('product-grid');
  grid.classList.remove('product-list');

  try {
    localStorage.setItem('spunge-collection-view', 'grid');
  } catch (e) {}
}

function listgridJavascript() {
  if (window.__spungeListGridBound) return;
  window.__spungeListGridBound = true;

  // Always lock collection to grid view
  setProductView('grid');

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.wblistgridbtn');
    if (!btn) return;
    event.preventDefault();
    setProductView('grid');
  });
}

document.addEventListener('shopify:section:load', function () {
  setProductView('grid');
});

listgridJavascript();

// Play autoplay videos only while at least half of them is on screen.
// IntersectionObserver replaces the old scroll handler, which read
// clientHeight/getBoundingClientRect on load and on scroll and showed up in
// Lighthouse as ~360ms of forced reflow.
window.addEventListener('load', function () {
  var videos = Array.prototype.filter.call(document.querySelectorAll('video[autoplay]'), function (v) {
    return !(v.closest('media-gallery') || v.closest('.slideshow-hero-video') || v.closest('.slideshow__slide--video'));
  });
  if (!videos.length || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var v = entry.target;
      if (entry.isIntersecting) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        v.pause();
      }
    });
  }, { threshold: 0.5 });
  videos.forEach(function (v) { io.observe(v); });
});

document.addEventListener('DOMContentLoaded', () => {
  // Nothing to tick on pages without a countdown; the old code ran a
  // querySelectorAll every second on every page, forever.
  if (!document.querySelector('.countd_all')) return;
  setInterval(countDown, 1000);
  countDown();

  function countDown() {
    const countCardSections = document.querySelectorAll('.countd_all');
    countCardSections.forEach((countdownSection) => {
      const countDownDate = new Date(countdownSection.getAttribute('data-date')).getTime();
      const now = Date.now();
      const distance = countDownDate - now;

      const daysElement = countdownSection.querySelector('.main_cdays .wb_cdays');
      const hoursElement = countdownSection.querySelector('.main_chours .wb_chours');
      const minutesElement = countdownSection.querySelector('.main_cminutes .wb_cminutes');
      const secondsElement = countdownSection.querySelector('.main_cseconds .wb_cseconds');
      const messageElement = countdownSection.querySelector('.main_ctext');

      if (!daysElement || !hoursElement || !minutesElement || !secondsElement) return;

      if (distance < 0 || isNaN(countDownDate)) {
        daysElement.textContent = '00';
        hoursElement.textContent = '00';
        minutesElement.textContent = '00';
        secondsElement.textContent = '00';

        if (messageElement && messageElement.textContent.trim() !== '') {
          daysElement.parentElement.style.display = 'none';
          hoursElement.parentElement.style.display = 'none';
          minutesElement.parentElement.style.display = 'none';
          secondsElement.parentElement.style.display = 'none';
          countdownSection.style.display = 'inline-block';
          messageElement.style.display = 'block';
        }
      } else {
        daysElement.textContent = Math.floor(distance / (1000 * 60 * 60 * 24));
        hoursElement.textContent = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        minutesElement.textContent = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        secondsElement.textContent = Math.floor((distance % (1000 * 60)) / 1000);
        if (messageElement) {
          messageElement.style.display = 'none';
        }
      }
    });
  }
});
